import { useState } from 'react';

import { CreditPopUpDataType } from './useCreditPopup';

export function checkInAppBrowser() {
  if (typeof navigator !== 'undefined') {
    const userAgent = navigator.userAgent || navigator.vendor;

    const inAppBrowserIdentifiers = [
      'FBAN', // Facebook
      'FBAV', // Facebook
      'Instagram', // Instagram
      'Twitter', // Twitter
      'Line', // Line
      'Snapchat', // Snapchat
      'WhatsApp', // WhatsApp
      'Messenger', // Facebook Messenger
      'LinkedIn', // LinkedIn
      'Pinterest', // Pinterest
    ];

    return inAppBrowserIdentifiers.some((identifier) =>
      userAgent.includes(identifier),
    );
  }
  return false;
}

export function useInAppBrowser() {
  const [popUpData, setPopUpData] = useState<CreditPopUpDataType>({
    header: 'Open Lesson Planner in the browser',
    isOpen: false,
    body: 'To continue using the app, kindly copy the link below and paste on Google Chrome or your chosen website browser.',
    bottomText: 'Sign in to use your FREE credits',
    isCloseable: false,
    copyLinkButton: true,
    showImage: false,
  });

  return { popUpData, setPopUpData };
}
